import { useDimensions } from 'react-native-web-hooks';

export const useIsMobile = (): boolean => {
  const { window } = useDimensions();
  const isMobile = window.width <= 960;

  return isMobile;
};
